module.exports = __webpack_public_path__ + "static/img/incheon-paralympic-pt.16279be.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/incheon-paralympic-pt.jpg
// module id = wzhD
// module chunks = 0